import { Button } from '@/components/ui/button'
import { displayDate } from '@/lib/dates'

export function CardOnlyPayment() {
  return (
    <section className="space-y-2 border-t border-border pt-4" aria-labelledby="payment-heading">
      <h2 id="payment-heading" className="text-body-sm font-medium">
        Payment
      </h2>
      <div className="rounded-md border border-border px-3 py-2">
        <span className="block text-body-sm">Pay online</span>
        <span className="block text-caption text-muted-foreground">Card · processed securely</span>
      </div>
    </section>
  )
}

export function EventPaymentOptions({
  value,
  dueOn,
  onChange,
}: {
  value: 'online' | 'invoice'
  dueOn?: string
  onChange: (value: 'online' | 'invoice') => void
}) {
  return (
    <section className="space-y-2 border-t border-border pt-4" aria-labelledby="payment-heading">
      <h2 id="payment-heading" className="text-body-sm font-medium">
        Payment
      </h2>
      <div className="space-y-3">
        <Button
          type="button"
          variant="outline"
          aria-pressed={value === 'online'}
          className="h-auto w-full justify-start px-3 py-2 text-left"
          onClick={() => onChange('online')}
        >
          <span>
            <span className="block text-body-sm">Pay online</span>
            <span className="block text-caption font-normal text-muted-foreground">
              Card · processed securely
            </span>
          </span>
        </Button>
        <Button
          type="button"
          variant="outline"
          aria-pressed={value === 'invoice'}
          className="h-auto w-full justify-start px-3 py-2 text-left"
          onClick={() => onChange('invoice')}
        >
          <span>
            <span className="block text-body-sm">Invoice me</span>
            <span className="block text-caption font-normal text-muted-foreground">
              Due {displayDate(dueOn ?? '')} · pay by card or check
            </span>
          </span>
        </Button>
      </div>
    </section>
  )
}
